/* Fabrica Kraft – "See it in your room" (v79, Oct 2026).
   Customer uploads a room photo, drags four corners over the seat / bench / window area,
   and the fabric chosen in the builder is painted on in perspective, keeping the photo's light and shadow.
   Everything runs in the browser: the photo never leaves the customer's device. */
(function () {
  'use strict';
  var root = document.querySelector('.fks');
  if (!root) return;

  var CSS = [
    '.fkv-open{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:46px;margin:0 0 16px;border:1px solid #111;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:15px;cursor:pointer}',
    '.fkv-open:hover{background:#111;color:#fff}',
    '.fkv-open small{font-size:12.5px;opacity:.65}',
    '.fkv{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;background:rgba(17,17,17,.6);padding:16px}',
    '.fkv[hidden]{display:none}',
    '.fkv__box{position:relative;width:min(1080px,100%);max-height:calc(100vh - 32px);overflow:auto;background:#fff;border-radius:20px;padding:20px;display:grid;grid-template-columns:1fr 280px;gap:20px}',
    '.fkv__x{position:absolute;top:10px;right:10px;width:40px;height:40px;border:0;border-radius:50%;background:#f1f0ec;font-size:22px;line-height:1;cursor:pointer;z-index:2}',
    '.fkv__stage{position:relative;background:#f1f0ec;border-radius:14px;overflow:hidden;min-height:320px;display:flex;align-items:center;justify-content:center;touch-action:none}',
    '.fkv__stage canvas{display:block;max-width:100%;max-height:calc(100vh - 120px);height:auto}',
    '.fkv__svg{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}',
    '.fkv__h{position:absolute;width:30px;height:30px;margin:-15px 0 0 -15px;border-radius:50%;background:#fff;border:2px solid #111;box-shadow:0 2px 8px rgba(0,0,0,.25);cursor:grab;touch-action:none}',
    '.fkv__h::after{content:"";position:absolute;inset:9px;border-radius:50%;background:#111}',
    '.fkv__drop{display:flex;flex-direction:column;align-items:center;gap:10px;padding:40px 20px;text-align:center;color:#4a4a47;font-size:14px}',
    '.fkv__drop b{font-size:18px;color:#111}',
    '.fkv__side h3{margin:0 0 6px;font-size:20px;font-weight:600}',
    '.fkv__side p{margin:0 0 12px;font-size:14px;line-height:1.5;color:#4a4a47}',
    '.fkv__fab{display:flex;align-items:center;gap:10px;margin:0 0 14px;padding:10px;border-radius:12px;background:#f6f5f2;font-size:14px}',
    '.fkv__fab img{width:44px;height:44px;border-radius:8px;object-fit:cover}',
    '.fkv__row{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 12px}',
    '.fkv__btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:40px;padding:0 16px;border:1px solid #d9d9d4;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:14px;cursor:pointer;text-decoration:none}',
    '.fkv__btn--dark{background:#111;border-color:#111;color:#fff}',
    '.fkv__btn[disabled]{opacity:.45;cursor:default}',
    '.fkv__lbl{display:block;font-size:13px;color:#4a4a47;margin:0 0 4px}',
    '.fkv__range{width:100%;margin:0 0 14px;accent-color:#111}',
    '.fkv__note{font-size:12.5px!important;color:#6b6b6b!important}',
    '.fkv__file{position:absolute;width:1px;height:1px;opacity:0}',
    '@media (max-width:749px){.fkv{padding:0}.fkv__box{grid-template-columns:1fr;max-height:100vh;height:100vh;border-radius:0;padding:56px 14px 20px}.fkv__stage canvas{max-height:58vh}}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  var CAM = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';

  /* ---------- state ---------- */
  var photo = null;          // ImageData of the uploaded photo (scaled)
  var W = 0, H = 0;          // photo size
  var lum = null, lumSoft = null; // luminance of the photo: sharp (recolour) and softened (new cushion)
  var pts = null;            // 4 corners [tl,tr,br,bl] in photo pixels
  var tex = null, texKey = '';// fabric texture ImageData
  var blend = 0.85;          // how much of the photo's light/shadow to keep
  var modal, cv, ctx, svg, handles = [], fileIn, saveBtn, shareBtn, fabBox, sizeTxt;

  function api() { return window.FKS; }
  function fabInfo() {
    var a = api(); if (!a) return null;
    var f = a.fab(); if (!f) return null;
    return { key: f.h || a.F.fab, name: a.name(f), img: a.img(f, 300), thumb: a.img(f, 120) };
  }
  function widthIn() { var a = api(); return a && a.F && a.F.w ? a.F.w : 48; }

  /* ---------- UI ---------- */
  function build() {
    modal = document.createElement('div');
    modal.className = 'fkv'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'See it in your room');
    modal.innerHTML =
      '<div class="fkv__box"><button type="button" class="fkv__x" aria-label="Close">×</button>' +
      '<div class="fkv__stage" data-v="stage"><div class="fkv__drop" data-v="drop">' + CAM +
      '<b>Add a photo of your room</b><span>Stand facing the bench, window seat or chair. A straight-on photo works best.</span>' +
      '<div class="fkv__row" style="justify-content:center"><button type="button" class="fkv__btn fkv__btn--dark" data-v="cam">' + CAM + 'Take photo</button>' +
      '<label class="fkv__btn">Choose photo<input class="fkv__file" type="file" accept="image/*" data-v="file"></label></div>' +
      '<input class="fkv__file" type="file" accept="image/*" capture="environment" data-v="camfile"></div></div>' +
      '<div class="fkv__side"><h3>See it in your room</h3>' +
      '<p>Drag the four dots onto the corners of your seat or bench top. We place a cushion in your chosen fabric and thickness.</p>' +
      '<p class="fkv__note">Already have a cushion there? Set thickness to <b>off</b> to recolour it instead.</p>' +
      '<div class="fkv__fab" data-v="fab"></div>' +
      '<span class="fkv__lbl">Cushion thickness · <b data-v="tval"></b></span><input class="fkv__range" type="range" min="0" max="8" step="0.5" value="3" data-v="thick" aria-label="Cushion thickness">' +
      '<span class="fkv__lbl">Light and shadow</span><input class="fkv__range" type="range" min="0" max="100" value="85" data-v="blend" aria-label="Light and shadow">' +
      '<span class="fkv__lbl">Pattern size</span><input class="fkv__range" type="range" min="40" max="250" value="100" data-v="scale" aria-label="Pattern size">' +
      '<div class="fkv__row"><button type="button" class="fkv__btn fkv__btn--dark" data-v="save" disabled>Save image</button>' +
      '<button type="button" class="fkv__btn" data-v="share" disabled>Share</button>' +
      '<button type="button" class="fkv__btn" data-v="cam2">Retake</button>' +
      '<label class="fkv__btn">New photo<input class="fkv__file" type="file" accept="image/*" data-v="file2"></label></div>' +
      '<p class="fkv__note">To try another fabric, close this, pick it in the builder and tap <b>See it in your room</b> again. Your photo stays.</p>' +
      '<p class="fkv__note">Your photo stays on your device and is never uploaded. The mockup is a guide: real colour can vary slightly by screen and dye lot.</p>' +
      '</div></div>';
    document.body.appendChild(modal);
    dropHTML = modal.querySelector('[data-v="stage"]').innerHTML;
    modal.querySelector('.fkv__x').onclick = close;
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    fileIn = modal.querySelector('[data-v="file"]');
    fileIn.onchange = onFile; modal.querySelector('[data-v="file2"]').onchange = onFile;
    fabBox = modal.querySelector('[data-v="fab"]');
    saveBtn = modal.querySelector('[data-v="save"]'); shareBtn = modal.querySelector('[data-v="share"]');
    saveBtn.onclick = save; shareBtn.onclick = share;
    modal.querySelector('[data-v="blend"]').oninput = function () { blend = this.value / 100; schedule(); };
    modal.querySelector('[data-v="scale"]').oninput = function () { scaleMul = this.value / 100; schedule(); };
    var th = modal.querySelector('[data-v="thick"]');
    th.oninput = function () { thickIn = +this.value; thickTouched = true; showThick(); schedule(); };
    modal.querySelector('[data-v="camfile"]').onchange = onFile;
    modal.querySelector('[data-v="cam"]').onclick = camera;
    modal.querySelector('[data-v="cam2"]').onclick = camera;
  }
  function showThick() {
    var t = modal.querySelector('[data-v="tval"]'), r = modal.querySelector('[data-v="thick"]');
    r.value = thickIn; t.textContent = thickIn ? thickIn + '″' : 'off (recolour only)';
  }

  /* ---------- camera: phones open the camera app; computers use the webcam ---------- */
  var mobile = /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.platform));
  function camera() {
    if (mobile || !(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { modal.querySelector('[data-v="camfile"]').click(); return; }
    var stage = modal.querySelector('[data-v="stage"]');
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1920 } }, audio: false }).then(function (stream) {
      stage.innerHTML = '<video playsinline autoplay muted style="max-width:100%;max-height:calc(100vh - 160px);display:block"></video>' +
        '<div class="fkv__row" style="position:absolute;bottom:12px;left:0;right:0;justify-content:center"><button type="button" class="fkv__btn fkv__btn--dark" data-v="snap">' + CAM + 'Capture</button><button type="button" class="fkv__btn" data-v="cancel">Cancel</button></div>';
      var v = stage.querySelector('video'); v.srcObject = stream;
      function stop() { stream.getTracks().forEach(function (t) { t.stop(); }); }
      stage.querySelector('[data-v="snap"]').onclick = function () {
        var c = document.createElement('canvas'); c.width = v.videoWidth; c.height = v.videoHeight; c.getContext('2d').drawImage(v, 0, 0);
        stop(); var img = new Image(); img.onload = function () { usePhoto(img); }; img.src = c.toDataURL('image/jpeg', 0.92);
      };
      stage.querySelector('[data-v="cancel"]').onclick = function () { stop(); if (photo) { setupStage(); render(); } else resetDrop(); };
      camStop = stop;
    }).catch(function () { modal.querySelector('[data-v="camfile"]').click(); });
  }
  var camStop = null, dropHTML = '';
  function resetDrop() { modal.querySelector('[data-v="stage"]').innerHTML = dropHTML; wireDrop(); }
  function wireDrop() {
    var st = modal.querySelector('[data-v="stage"]');
    var f = st.querySelector('[data-v="file"]'); if (f) f.onchange = onFile;
    var c = st.querySelector('[data-v="cam"]'); if (c) c.onclick = camera;
    var cf = st.querySelector('[data-v="camfile"]'); if (cf) cf.onchange = onFile;
  }
  var scaleMul = 1, thickIn = 3, thickTouched = false;

  function button() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'fkv-open';
    b.innerHTML = CAM + '<span>See it in your room</span><small>upload a photo</small>';
    b.onclick = open;
    var room = root.querySelector('[data-fks="room"]');
    var media = root.querySelector('.fkb__media');
    if (room && room.parentNode) room.parentNode.insertBefore(b, room.nextSibling);
    else if (media) media.appendChild(b);
    else { var s = root.querySelector('.fkb__summary'); if (s) s.parentNode.insertBefore(b, s); }
  }

  function open() {
    if (!modal) build();
    var f = fabInfo();
    fabBox.innerHTML = f ? '<img alt="" src="' + f.thumb + '"><span><b>' + esc(f.name) + '</b><br><span data-v="size"></span></span>'
                         : '<span>Choose a fabric in the builder first, then come back here.</span>';
    sizeTxt = fabBox.querySelector('[data-v="size"]');
    if (sizeTxt) sizeTxt.textContent = 'Cushion ' + widthIn() + '″ wide';
    var a = api(); if (!thickTouched && a && a.F) thickIn = a.F.t || 0;
    showThick();
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    if (photo) loadTex(function () { render(); });
  }
  function close() { if (camStop) { camStop(); camStop = null; if (photo) { setupStage(); render(); } else resetDrop(); } modal.hidden = true; document.documentElement.style.overflow = ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- photo ---------- */
  function onFile(e) {
    var file = e.target.files && e.target.files[0]; if (!file) return;
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () { usePhoto(img); URL.revokeObjectURL(url); };
    img.src = url; e.target.value = '';
  }
  function usePhoto(img) {
    camStop = null;
    (function () {
      var max = 1400, s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      W = Math.round(img.naturalWidth * s); H = Math.round(img.naturalHeight * s);
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
      photo = x.getImageData(0, 0, W, H);
      lum = new Float32Array(W * H);
      for (var i = 0, d = photo.data; i < W * H; i++) lum[i] = 0.3 * d[i * 4] + 0.59 * d[i * 4 + 1] + 0.11 * d[i * 4 + 2];
      lumSoft = boxBlur(lum, W, H, Math.max(4, Math.round(Math.max(W, H) * 0.025)));
      pts = [[W * 0.27, H * 0.56], [W * 0.73, H * 0.56], [W * 0.78, H * 0.68], [W * 0.22, H * 0.68]];
      setupStage(); loadTex(function () { render(); });
    })();
  }

  function setupStage() {
    var stage = modal.querySelector('[data-v="stage"]');
    stage.innerHTML = '';
    cv = document.createElement('canvas'); cv.width = W; cv.height = H; ctx = cv.getContext('2d');
    cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Your room with the chosen fabric');
    stage.appendChild(cv);
    svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('class', 'fkv__svg');
    svg.innerHTML = '<polygon fill="none" stroke="#fff" stroke-width="2" stroke-dasharray="6 5" vector-effect="non-scaling-stroke"/>';
    stage.appendChild(svg);
    handles = pts.map(function (p, i) {
      var h = document.createElement('div'); h.className = 'fkv__h'; h.tabIndex = 0;
      h.setAttribute('role', 'slider'); h.setAttribute('aria-label', ['Back left corner', 'Back right corner', 'Front right corner', 'Front left corner'][i]);
      stage.appendChild(h); drag(h, i); return h;
    });
    saveBtn.disabled = shareBtn.disabled = false;
    window.addEventListener('resize', placeHandles);
    placeHandles();
  }
  function box() { var r = cv.getBoundingClientRect(), s = cv.parentNode.getBoundingClientRect(); return { x: r.left - s.left, y: r.top - s.top, k: r.width / W }; }
  function placeHandles() {
    if (!cv) return; var b = box();
    handles.forEach(function (h, i) { h.style.left = (b.x + pts[i][0] * b.k) + 'px'; h.style.top = (b.y + pts[i][1] * b.k) + 'px'; });
    svg.setAttribute('viewBox', '0 0 ' + cv.parentNode.clientWidth + ' ' + cv.parentNode.clientHeight);
    svg.firstChild.setAttribute('points', pts.map(function (p) { return (b.x + p[0] * b.k) + ',' + (b.y + p[1] * b.k); }).join(' '));
  }
  function drag(h, i) {
    h.addEventListener('pointerdown', function (e) {
      e.preventDefault(); h.setPointerCapture(e.pointerId);
      function mv(ev) {
        var b = box(), s = cv.parentNode.getBoundingClientRect();
        pts[i] = [Math.max(0, Math.min(W, (ev.clientX - s.left - b.x) / b.k)), Math.max(0, Math.min(H, (ev.clientY - s.top - b.y) / b.k))];
        placeHandles(); schedule();
      }
      function up() { h.removeEventListener('pointermove', mv); h.removeEventListener('pointerup', up); render(); }
      h.addEventListener('pointermove', mv); h.addEventListener('pointerup', up);
    });
    h.addEventListener('keydown', function (e) {
      var d = { ArrowLeft: [-4, 0], ArrowRight: [4, 0], ArrowUp: [0, -4], ArrowDown: [0, 4] }[e.key]; if (!d) return;
      e.preventDefault(); pts[i] = [pts[i][0] + d[0], pts[i][1] + d[1]]; placeHandles(); schedule();
    });
  }

  /* ---------- fabric texture ---------- */
  function loadTex(cb) {
    var f = fabInfo(); if (!f || !f.img) { tex = null; cb(); return; }
    if (tex && texKey === f.img) { cb(); return; }
    var done = false;
    function got(img) {
      if (done) return; done = true;
      try {
        var n = Math.min(img.naturalWidth, img.naturalHeight, 512), c = document.createElement('canvas'); c.width = c.height = n;
        var x = c.getContext('2d'), m = Math.min(img.naturalWidth, img.naturalHeight) * 0.55;
        x.drawImage(img, (img.naturalWidth - m) / 2, (img.naturalHeight - m) / 2, m, m, 0, 0, n, n);
        tex = x.getImageData(0, 0, n, n); texKey = f.img;
        /* even out the swatch photo's own lighting so only the room's light shows */
        var d = tex.data, sum = 0, i; for (i = 0; i < d.length; i += 4) sum += 0.3 * d[i] + 0.59 * d[i + 1] + 0.11 * d[i + 2];
        tex.mean = sum / (d.length / 4);
      } catch (e) { tex = null; }
      cb();
    }
    function load(src) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () { got(img); };
      img.onerror = function () { if (src.indexOf('fkv=') > 0 && !done) { done = true; tex = null; cb(); } };
      img.src = src; loadTex.pending = img;
    }
    load(f.img);
    /* if the swatch is still downloading for the builder, fetch our own copy rather than wait */
    setTimeout(function () { if (!done) load(f.img + (f.img.indexOf('?') < 0 ? '?' : '&') + 'fkv=1'); }, 1200);
  }

  /* ---------- perspective paint ---------- */
  function homography(src, dst) {
    /* maps unit square corners (src) to quad (dst); returns inverse for pixel -> (u,v) */
    var A = [], b = [];
    for (var i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], X = dst[i][0], Y = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -X * x, -X * y]); b.push(X);
      A.push([0, 0, 0, x, y, 1, -Y * x, -Y * y]); b.push(Y);
    }
    var h = solve(A, b); if (!h) return null;
    var M = [[h[0], h[1], h[2]], [h[3], h[4], h[5]], [h[6], h[7], 1]];
    return inv3(M);
  }
  function solve(A, b) {
    var n = 8, i, j, k;
    for (i = 0; i < n; i++) A[i].push(b[i]);
    for (i = 0; i < n; i++) {
      var p = i; for (j = i + 1; j < n; j++) if (Math.abs(A[j][i]) > Math.abs(A[p][i])) p = j;
      var t = A[i]; A[i] = A[p]; A[p] = t;
      if (Math.abs(A[i][i]) < 1e-12) return null;
      for (j = i + 1; j < n; j++) { var f = A[j][i] / A[i][i]; for (k = i; k <= n; k++) A[j][k] -= f * A[i][k]; }
    }
    var x = new Array(n);
    for (i = n - 1; i >= 0; i--) { var s = A[i][n]; for (j = i + 1; j < n; j++) s -= A[i][j] * x[j]; x[i] = s / A[i][i]; }
    return x;
  }
  function inv3(m) {
    var a = m[0][0], b = m[0][1], c = m[0][2], d = m[1][0], e = m[1][1], f = m[1][2], g = m[2][0], h = m[2][1], i = m[2][2];
    var A = e * i - f * h, B = -(d * i - f * g), C = d * h - e * g, det = a * A + b * B + c * C;
    if (Math.abs(det) < 1e-12) return null;
    return [[A / det, -(b * i - c * h) / det, (b * f - c * e) / det], [B / det, (a * i - c * g) / det, -(a * f - c * d) / det], [C / det, -(a * h - b * g) / det, (a * e - b * d) / det]];
  }
  function inside(px, py, q) {
    var c = false;
    for (var i = 0, j = 3; i < 4; j = i++) if ((q[i][1] > py) !== (q[j][1] > py) && px < (q[j][0] - q[i][0]) * (py - q[i][1]) / (q[j][1] - q[i][1]) + q[i][0]) c = !c;
    return c;
  }

  /* the swatch scaled to roughly one on-screen repeat, so fine weaves don't sparkle */
  var sizedCache = { n: 0, key: '', d: null };
  function sized(n) {
    n = Math.max(12, Math.min(tex.width, n));
    if (sizedCache.d && sizedCache.n === n && sizedCache.key === texKey) return sizedCache.d;
    var a = document.createElement('canvas'); a.width = a.height = tex.width; a.getContext('2d').putImageData(tex, 0, 0);
    var c = document.createElement('canvas'); c.width = c.height = n;
    var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(a, 0, 0, n, n);
    sizedCache = { n: n, key: texKey, d: x.getImageData(0, 0, n, n) };
    return sizedCache.d;
  }

  var raf = 0;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; render(); }); }

  /* box blur through an integral image: keeps the room's light falloff, drops object detail */
  function boxBlur(src, w, h, r) {
    var I = new Float64Array((w + 1) * (h + 1)), out = new Float32Array(w * h), x, y;
    for (y = 1; y <= h; y++) { var row = 0; for (x = 1; x <= w; x++) { row += src[(y - 1) * w + x - 1]; I[y * (w + 1) + x] = I[(y - 1) * (w + 1) + x] + row; } }
    for (y = 0; y < h; y++) {
      var y0 = Math.max(0, y - r), y1 = Math.min(h, y + r + 1);
      for (x = 0; x < w; x++) {
        var x0 = Math.max(0, x - r), x1 = Math.min(w, x + r + 1);
        out[y * w + x] = (I[y1 * (w + 1) + x1] - I[y0 * (w + 1) + x1] - I[y1 * (w + 1) + x0] + I[y0 * (w + 1) + x0]) / ((x1 - x0) * (y1 - y0));
      }
    }
    return out;
  }
  function sm(a, b, x) { var t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); }

  /* paint one face of the cushion: quad is [tl,tr,br,bl]; shader(u,v) returns
     {skip, tu, tv (inches on the fabric), k (synthetic light)} */
  function face(od, q, shader, ref, pmix, small, ipt, L) {
    var Hm = homography([[0, 0], [1, 0], [1, 1], [0, 1]], q); if (!Hm) return;
    var minX = Math.max(0, Math.floor(Math.min(q[0][0], q[1][0], q[2][0], q[3][0]))),
        maxX = Math.min(W - 1, Math.ceil(Math.max(q[0][0], q[1][0], q[2][0], q[3][0]))),
        minY = Math.max(0, Math.floor(Math.min(q[0][1], q[1][1], q[2][1], q[3][1]))),
        maxY = Math.min(H - 1, Math.ceil(Math.max(q[0][1], q[1][1], q[2][1], q[3][1])));
    var tn = small.width, td = small.data, norm = Math.min(1.25, (128 / (tex.mean || 128)) * 0.5 + 0.5);
    for (var y = minY; y <= maxY; y++) {
      for (var x = minX; x <= maxX; x++) {
        if (!inside(x + 0.5, y + 0.5, q)) continue;
        var w = Hm[2][0] * x + Hm[2][1] * y + Hm[2][2], u = (Hm[0][0] * x + Hm[0][1] * y + Hm[0][2]) / w, v = (Hm[1][0] * x + Hm[1][1] * y + Hm[1][2]) / w;
        var r = shader(Math.max(0, Math.min(1, u)), Math.max(0, Math.min(1, v)));
        if (r.skip) continue;
        var fu = r.tu / ipt, fv = r.tv / ipt, iu = Math.floor(fu), iv = Math.floor(fv); fu -= iu; fv -= iv; if (iu & 1) fu = 1 - fu; if (iv & 1) fv = 1 - fv;
        var tx = Math.min(tn - 1, Math.floor(fu * tn)), ty = Math.min(tn - 1, Math.floor(fv * tn)), ti = (ty * tn + tx) * 4;
        var p = Math.min(1.3, Math.max(0.35, L[y * W + x] / Math.max(1, ref)));
        var k = r.k * (1 + (p - 1) * pmix);
        var a = (r.a == null ? 1 : r.a) * ((inside(x - 1.2, y, q) && inside(x + 1.2, y, q) && inside(x, y - 1.2, q) && inside(x, y + 1.2, q)) ? 1 : 0.6);
        var oi = (y * W + x) * 4;
        for (var c = 0; c < 3; c++) od[oi + c] = od[oi + c] * (1 - a) + Math.min(255, td[ti + c] * norm * k) * a;
      }
    }
  }

  function render() {
    if (!photo || !ctx) return;
    var out = new ImageData(new Uint8ClampedArray(photo.data), W, H), od = out.data;
    if (tex) {
      var a = api(), F = (a && a.F) || {};
      var wIn = widthIn(), dIn = Math.max(4, F.d || 18), tIn = thickIn, roll = Math.min(1, tIn / 2.5);
      var welt = !!F.welt && tIn > 0, rIn = Math.min(0.9, Math.min(wIn, dIn) * 0.06);
      var frontPx = Math.hypot(pts[2][0] - pts[3][0], pts[2][1] - pts[3][1]), ppi = frontPx / wIn, tpx = tIn * ppi;
      /* light reference: the area's own brightness, so shading is relative to the seat */
      var bx0 = Math.max(0, Math.floor(Math.min(pts[0][0], pts[3][0]))), bx1 = Math.min(W - 1, Math.ceil(Math.max(pts[1][0], pts[2][0])));
      var by0 = Math.max(0, Math.floor(Math.min(pts[0][1], pts[1][1]))), by1 = Math.min(H - 1, Math.ceil(Math.max(pts[2][1], pts[3][1]) + tpx));
      var vals = [], x, y, step = Math.max(2, Math.round(Math.sqrt((bx1 - bx0) * (by1 - by0) / 5000)));
      var L = tIn > 0 ? lumSoft : lum;
      for (y = by0; y <= by1; y += step) for (x = bx0; x <= bx1; x += step) vals.push(L[y * W + x]);
      vals.sort(function (p, q) { return p - q; });
      var ref = vals.length ? vals[Math.floor(vals.length * 0.6)] : 128;
      var ipt = 6 * scaleMul, small = sized(Math.round(ppi * ipt)), pmix = tIn > 0 ? blend * 0.7 : blend;
      var bl = pts[3], br = pts[2], ov = 2, fq = [[bl[0], bl[1] - ov], [br[0], br[1] - ov], [br[0], br[1] + tpx], [bl[0], bl[1] + tpx]];  /* front face tucks 2px under the top so no seam shows */

      if (tpx > 1) {
        /* soft contact shadow under the cushion */
        var len = Math.max(3, tpx * 0.18);
        for (x = Math.max(0, Math.floor(bl[0])); x <= Math.min(W - 1, Math.ceil(br[0])); x++) {
          var t = (x - bl[0]) / Math.max(1, br[0] - bl[0]), yb = bl[1] + (br[1] - bl[1]) * t + tpx;
          var endFade = sm(0, 0.04, t) * sm(0, 0.04, 1 - t);
          for (var dy = 0; dy < len; dy++) {
            y = Math.round(yb + dy); if (y < 0 || y >= H) continue;
            var f = 1 - 0.45 * Math.pow(1 - dy / len, 2) * endFade, oi = (y * W + x) * 4;
            od[oi] *= f; od[oi + 1] *= f; od[oi + 2] *= f;
          }
        }
        /* front face: convex like a real boxed cushion, with rounded vertical ends and optional piping */
        var weltIn = 0.3, rEnd = Math.min(2, tIn * 0.55);
        face(od, fq, function (u, sv) {
          var ex = Math.min(u, 1 - u) * wIn;
          var inset = rEnd * (1 - Math.sqrt(Math.max(0, 1 - Math.pow(2 * sv - 1, 2))));
          if (ex < inset) return { skip: true };
          var k = 0.8 - 0.26 * sm(0, 1, sv) + 0.05 * Math.sin(Math.PI * sv);              // continues the roll from the top, darker underneath
          k *= 0.7 + 0.3 * sm(inset, inset + rEnd * 1.3, ex);                               // ends turn away
          if (welt) {
            var wb = weltIn / tIn;
            if (sv < wb) k = 0.8 + 0.16 * Math.sin(Math.PI * sv / wb);
            else if (sv > 1 - wb) k = 0.55 + 0.14 * Math.sin(Math.PI * (sv - (1 - wb)) / wb);
          }
          return { tu: u * wIn, tv: sv * tIn, k: k };
        }, ref, pmix, small, ipt, L);
      }

      /* top: soft crown, edges rolling away, rounded corners */
      var rTop = tIn > 0 ? Math.min(2, Math.max(0.6, tIn * 0.4)) : 0, R = Math.max(0.8, Math.min(2.6, tIn * 0.7));
      face(od, pts, function (u, v) {
        var ex = Math.min(u, 1 - u) * wIn, eb = v * dIn, ef = (1 - v) * dIn, ey = Math.min(eb, ef);
        if (rTop && ex < rTop && ey < rTop) { var cx = rTop - ex, cy = rTop - ey; if (cx * cx + cy * cy > rTop * rTop) return { skip: true }; }
        if (!tIn) return { tu: u * wIn, tv: v * dIn, k: 1 };
        var side = 0.58 + 0.42 * Math.sin(Math.PI / 2 * Math.min(1, Math.min(ex, eb * 1.2) / R));   // sides and back roll away
        var front = 0.8 + 0.2 * Math.sin(Math.PI / 2 * Math.min(1, ef / R));                         // front rolls towards you
        var k = Math.min(side, front);
        var cu = (u - 0.5) * 2, cv = (v - 0.42) * 2;
        k += 0.1 * Math.max(0, 1 - (cu * cu * 0.6 + cv * cv));                             // broad crown highlight
        k -= 0.06 * v;                                                                     // light from behind/above
        if (welt && ef < 0.3) k = 0.8 + 0.18 * Math.sin(Math.PI * ef / 0.3);
        return { tu: u * wIn, tv: v * dIn, k: 1 + (k - 1) * roll };
      }, ref, pmix, small, ipt, L);
    }
    ctx.putImageData(out, 0, 0);
  }

  /* ---------- save / share ---------- */
  function fileName() { var f = fabInfo(); return 'fabrica-kraft-' + (f ? f.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') : 'mockup') + '.jpg'; }
  function save() {
    if (!cv) return;
    var a = document.createElement('a'); a.download = fileName(); a.href = cv.toDataURL('image/jpeg', 0.9);
    document.body.appendChild(a); a.click(); a.remove();
  }
  function share() {
    if (!cv) return;
    cv.toBlob(function (blob) {
      var f = fabInfo(), file = new File([blob], fileName(), { type: 'image/jpeg' });
      var data = { title: 'My room in ' + (f ? f.name : 'Fabrica Kraft fabric'), text: 'Designed on Fabrica Kraft: ' + location.href, files: [file] };
      if (navigator.canShare && navigator.canShare({ files: [file] })) navigator.share(data).catch(function () {});
      else save();
    }, 'image/jpeg', 0.9);
  }

  /* ---------- start once the builder is ready ---------- */
  var tries = 0;
  (function wait() { if (api()) { button(); return; } if (++tries < 100) setTimeout(wait, 150); })();
  window.FKV = { open: open };
})();
